import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, Crown } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function PaymentResult({ success }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState({ payment_status: "pending" });
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!success || !sessionId) return;
    let cancelled = false;
    const poll = async () => {
      if (cancelled) return;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setStatus(data);
        if (data.payment_status === "paid" || tries > 15) return;
        setTimeout(() => setTries((t) => t + 1), 2000);
      } catch {
        setTimeout(() => setTries((t) => t + 1), 2000);
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId, tries, success]);

  const paid = status.payment_status === "paid";

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {!success ? (
          <>
            <XCircle className="w-16 h-16 text-neon-red mx-auto mb-6" />
            <h1 className="font-heading text-3xl font-black mb-2">Pago cancelado</h1>
            <p className="text-muted-foreground mb-8">Nada fue cobrado. Vuelve cuando quieras pujar.</p>
          </>
        ) : paid ? (
          <>
            <div className="w-20 h-20 rounded-full bg-neon-gold/15 border border-neon-gold flex items-center justify-center mx-auto mb-6 animate-glow-gold">
              <Crown className="w-10 h-10 text-neon-gold" />
            </div>
            <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-neon-gold mb-2">
              BID CONFIRMED
            </div>
            <h1 className="font-heading text-3xl font-black mb-2 shine-text">¡Estás en el ring!</h1>
            <p className="text-muted-foreground mb-8">
              Tu bid de <span className="font-mono text-neon-cyan">${status.amount?.toFixed(2)}</span> fue registrado.
              Ahora aparece en el leaderboard.
            </p>
          </>
        ) : (
          <>
            <Loader2 className="w-12 h-12 text-neon-cyan animate-spin mx-auto mb-6" />
            <h1 className="font-heading text-2xl font-black mb-2">Confirmando pago...</h1>
            <p className="text-muted-foreground text-sm mb-8">Esto tarda un par de segundos.</p>
          </>
        )}
        <Button
          data-testid="return-home-button"
          onClick={() => navigate("/")}
          className="bg-neon-cyan hover:bg-neon-cyan/90 text-black font-bold rounded-full px-8"
        >
          Volver al leaderboard
        </Button>
      </div>
    </div>
  );
}
